export const FETCH_REGION_ERROR = 'Henting av regioner mislyktes';
export const FETCH_COMPANY_LIST_ERROR = 'Kunne ikke hente selskapsliste';
